import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedPipes } from './shared/pipes/shared-pipes.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxStarsModule } from 'ngx-stars';
import { FormsModule } from '@angular/forms';
import { ServerErrorComponent } from './server-error/server-error.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { RemoteAccessComponent } from './remote-access/remote-access.component';
import { DigitalMenusComponent } from './digital-menus/digital-menus.component';
import { ProductDetailsComponent } from './digital-menus/product-details/product-details.component';
import { SharedModule } from './shared/modules/shared.module';
import { ReservationsComponent } from './reservations/reservations.component';
import { MyReservationsComponent } from './reservations/my-reservations/my-reservations.component';
import { LinkpagesComponent } from './linkpages/linkpages.component';
import { SelfserviceComponent } from './selfservice/selfservice.component';
import { SelectedProductComponent } from './selfservice/selected-product/selected-product.component';
import { SscartComponent } from './selfservice/sscart/sscart.component';
import { SsbillComponent } from './selfservice/ssbill/ssbill.component';
import { HomeComponent } from './home/home.component';
import { InstallComponent } from './install/install.component';
import { PrivacyComponent } from './legal/privacy/privacy.component';
import { TermsComponent } from './legal/terms/terms.component';
import { InstallStepsComponent } from './install/install-steps/install-steps.component';
import { SignupLeadComponent } from './signup/lead/signup-lead.component';
import { SignupComponent } from './signup/signup.component';
import { PlanCardComponent } from './signup/plan-card/plan-card.component';
import { CustomerAreaComponent } from './customer-area/customer-area.component';
import { GoogleButtonComponent } from './signup/google-button/google-button.component';

@NgModule({ declarations: [
        AppComponent,
        ServerErrorComponent,
        RemoteAccessComponent,
        DigitalMenusComponent,
        ReservationsComponent,
        MyReservationsComponent,
        LinkpagesComponent,
        SelfserviceComponent,
        SelectedProductComponent,
        ProductDetailsComponent,
        SscartComponent,
        SsbillComponent,
        HomeComponent,
        InstallComponent,
        PrivacyComponent,
        TermsComponent,
        InstallStepsComponent,
        SignupLeadComponent,
        SignupComponent,
        PlanCardComponent,
        CustomerAreaComponent,
        GoogleButtonComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NgbModule,
        FontAwesomeModule,
        NgxStarsModule,
        FormsModule,
        SharedModule,
        NgxMaskDirective,
        NgxMaskPipe,
        BsDatepickerModule
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        provideNgxMask({validation: false})
    ] })
export class AppModule { }
